// extracted by mini-css-extract-plugin
export default {"popup":"ThankYouPopUp_popup__ym4Jx","popup-content":"ThankYouPopUp_popup-content__WWpxd"};